import { AxiosError } from 'axios';

export const roundOf = (n, p) => {
  // https://stackoverflow.com/a/49862458
  const n1 = n * Math.pow(10, p + 1);
  const n2 = Math.floor(n1 / 10);
  if (n1 >= n2 * 10 + 5) {
    return (n2 + 1) / Math.pow(10, p);
  }
  return n2 / Math.pow(10, p);
};

export const handleError = (err: AxiosError) => {
  if (err?.response?.status === 400) {
    console.log("ERROR", err?.response?.data?.errors);
    err?.response?.data?.errors?.forEach((element) => {
      alert(element);
    });
  } else {
    console.error("ERROR CODE", err?.response?.status, err?.response?.statusText);
    console.error("ERROR", err?.response?.data);
  }
};


export function truncateString(str, maxLength) {
  if (str === undefined || !str) return '';
  if (typeof str === 'number') {
    return str.toString();
  }
  if (str.length <= maxLength) {
    return str;
  } else {
    return str.slice(0, maxLength) + '...';
  }
}

